import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recordings")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/episodes" });
  },
});
